import type { FC } from 'react';
interface Props {
  netTotal: number;
}

const Totals: FC<Props> = ({ netTotal }) => {
  return (
    <div className="px-3 py-2">
      <div className="flex justify-between">
        <div className="font-bold">Net total</div>
        <div>€ {netTotal}</div>
      </div>
    </div>
  );
};

export default Totals;
